import * as marietta from '../..';
import { ThreeView } from '../../view3d/webcad';
import { ObjectType } from '../../view3d/webcad/ObjectType';
import { OctreeManager } from '../../view3d/webcad/Octree/OctreeManager';

export default class MiniMapManager {
    ua: marietta.webcad.manager.UserAgentManager;

    _MINIMAPWIDTH: number = 320;

    _MINIMAPHEIGHT: number = 240;

    get MINIMAPWIDTH(): number {
      if (this.ua.isMobile && this.minimapType === 0) return this._MINIMAPWIDTH / 2;
      return this._MINIMAPWIDTH;
    }

    get MINIMAPHEIGHT(): number {
      if (this.ua.isMobile && this.minimapType === 0) return this._MINIMAPHEIGHT / 2;
      return this._MINIMAPHEIGHT;
    }

    minimapType: number = 0; // 画像の種類

    floor1: marietta.webcad.view.MiniMap;

    floor2: marietta.webcad.view.MiniMap;

    floor3: marietta.webcad.view.MiniMap;

    current: marietta.webcad.view.MiniMapCurrent;

    constructor() {
      // 表示切替ボタンのイベント設定
      this.ua = marietta.webcad.WebCADGlobal.userAgentManager;
      const self = this;
      if (!this.ua.isPC) document.getElementById('apprMinimap').addEventListener('change', self.btnToggleMapHandler);
    }

    // 2D上の元のサイズ(px)
    _widthOrigin: number;

    get widthOrigin(): number {
      return this._widthOrigin;
    }

    set widthOrigin(value: number) {
      this._widthOrigin = value;
    }

    _heightOrigin: number;

    get heightOrigin(): number {
      return this._heightOrigin;
    }

    set heightOrigin(value: number) {
      this._heightOrigin = value;
    }

    // 縮尺
    _scaleSize: number;

    set scaleSize(value: number) {
      this._scaleSize = value;
    }

    get scaleSize() {
      return this._scaleSize;
    }

    viewObj: HTMLElement = null;

    /**
     * ミニマップの作成
     */
    createMiniMap(cb) {
      this.viewObj = document.getElementById('topview');
      if (!this.ua.isPC) {
        this.viewObj.style.width = `${this.MINIMAPWIDTH}px`;
        this.viewObj.style.height = `${this.MINIMAPHEIGHT}px`;
      }

      // 表示中の各フロアのバウンディングボックスを取得
      marietta.webcad.WebCADGlobal.scrollerManager.setScale(1);
      document.getElementById('webcad2dViewInner').scrollLeft = 0;
      document.getElementById('webcad2dViewInner').scrollTop = 0;

      // safariだと非表示レイヤーのバウンド情報が取得できないため、3Fに切り替えて全フロアを表示する
      const motoFloor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
      marietta.webcad.WebCADGlobal.changeFloor(3);

      let boundInfo;
      const p = new Promise((resolve: Function) => {
        switch (this.minimapType) {
          case 0:
          // ミニマップ用は、部屋のみのバウンド情報を取得
            boundInfo = marietta.webcad.WebCADGlobal.layerGroup.getRoomBoundInfo(resolve);
            break;
          case 1:
          // キャプチャ用は、寸法線と敷地、エクステリアを除いたバウンド情報
            boundInfo = marietta.webcad.WebCADGlobal.layerGroup.getBoundInfo(false, false, resolve);
            break;
          default: break;
        }
      });

      const self: marietta.webcad.manager.MiniMapManager = this;
      p.then(() => {
        // バウンド情報がなければ終了
        if (!boundInfo.minPoint) { cb(); return; }

        const imagePoint = {
          x: (boundInfo.minPoint.x) / marietta.webcad.WebCADGlobal.scaleSize,
          y: (boundInfo.minPoint.y) / marietta.webcad.WebCADGlobal.scaleSize,
          w: (boundInfo.maxPoint.x - boundInfo.minPoint.x) / marietta.webcad.WebCADGlobal.scaleSize,
          h: (boundInfo.maxPoint.y - boundInfo.minPoint.y) / marietta.webcad.WebCADGlobal.scaleSize,
        };

        // 元のサイズを保持
        self.widthOrigin = imagePoint.w;
        self.heightOrigin = imagePoint.h;

        // オリジナルサイズ
        let diff: number;
        if (imagePoint.w / 4 > imagePoint.h / 3) {
          const moto = imagePoint.h;
          imagePoint.h = (imagePoint.w / 4) * 3;
          diff = imagePoint.h - moto;

          // 表示位置を中央に
          imagePoint.y -= diff / 2;

          // 縮尺を保持
          const scale = self.MINIMAPWIDTH / self.widthOrigin;
          self.scaleSize = scale;
        } else {
          const moto = imagePoint.w;
          imagePoint.w = (imagePoint.h / 3) * 4;
          diff = imagePoint.w - moto;

          // 表示位置を中央に
          imagePoint.x -= diff / 2;

          // 縮尺を保持
          const scale = self.MINIMAPHEIGHT / self.heightOrigin;
          self.scaleSize = scale;
        }

        // クリア
        self.removeCurrent();
        self.removeAllFloor();

        // ミニマップを作成
        self.floor1 = new marietta.webcad.view.MiniMap(1, imagePoint.x, imagePoint.y, imagePoint.w, imagePoint.h, self.minimapType, self.MINIMAPWIDTH, self.MINIMAPHEIGHT, (() => {
          self.floor2 = new marietta.webcad.view.MiniMap(2, imagePoint.x, imagePoint.y, imagePoint.w, imagePoint.h, self.minimapType, self.MINIMAPWIDTH, self.MINIMAPHEIGHT, (() => {
            self.floor3 = new marietta.webcad.view.MiniMap(3, imagePoint.x, imagePoint.y, imagePoint.w, imagePoint.h, self.minimapType, self.MINIMAPWIDTH, self.MINIMAPHEIGHT, (() => {
              // 現在地アイコンを追加
              self.current = new marietta.webcad.view.MiniMapCurrent(self.minimapType);

              self.viewObj.addEventListener('click', self.onMouseDownHandler);
              self.viewObj.addEventListener('pointerdown', (e) => {
                e.stopPropagation();
              });
              self.viewObj.addEventListener('pointerup', (e) => {
                e.stopPropagation();
              });

              self.viewObj.addEventListener('mouseover', (e) => {

                if (ThreeView.get().isOperation == true) return;

                if (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.TextureAndItemDialog
                    || marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialog
                    || marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialogStarts) {
                        return;
                }

                // camera pinが選択されていたら
                if (ObjectType.isCameraPin(ThreeView.get().ItemDragManager.target)) return;

                ThreeView.get().controller.minimapIn();

                ThreeView.get().unSelectedObject();
                ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
                ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
              });
              self.viewObj.addEventListener('mouseout', (e) => {
                if (ThreeView.get().isOperation == true) return;
                ThreeView.get().controller.minimapOut();
              });



              // 元のフロアに表示を戻す
              marietta.webcad.WebCADGlobal.changeFloor(motoFloor);
              cb();
            }));
          }));
        }));
      }).catch((msg) => {
        console.log(msg);
      });
    }

    /**
     * 対象のフロアを削除
     */
    removeFloor(targetFloor: number) {
      const target = `floor${String(targetFloor)}`;
      if (!this[target]) return;
      (this[target].viewObj).remove();
      this[target] = null;
    }

    /**
     * 全フロアを削除
     */
    removeAllFloor() {
      this.removeFloor(1);
      this.removeFloor(2);
      this.removeFloor(3);
    }

    /**
     * 現在地を削除
     */
    removeCurrent() {
      if (!this.current) return;
      this.current.remove();
      this.current = null;
    }

    /**
     * 表示するフロアを変更
     */
    changeFloor(targetFloor: number) {
      const target = `floor${String(targetFloor)}`;
      if (!this[target]) return;

      this.floor1.viewObj.style.display = 'none';
      if (this.floor2) this.floor2.viewObj.style.display = 'none';
      if (this.floor3) this.floor3.viewObj.style.display = 'none';

      this[target].viewObj.style.display = 'block';
    }

    /**
     * クリックされた
     */
    onMouseDownHandler = (e) => {
      // 現在地カーソルを移動を移動
      const bound:DOMRect = this.viewObj.getBoundingClientRect();
      let dx;
      let dy;
      if (this.ua.isPC) {
        dx = e.clientX - bound.left - 20;
        dy = e.clientY - bound.top - 20;
      } else if (this.ua.isTablet) {
        dx = (e.clientX - bound.left - 20) * 2;
        dy = (e.clientY - bound.top - 20) * 2;
      } else {
        dx = (e.clientX - bound.left - 10) * 2;
        dy = (e.clientY - bound.top - 10) * 2;
      }

      // ウォークスルーカメラを移動
      const pt = new marietta.core.Point(dx, dy); // ミニマップのマージン分
      marietta.view3d.webcad.View3dGlobal.shared.setCameraFromMiniPt(pt);

      // 3D形状の選択解除
      ThreeView.get().unSelectedObject();
      e.stopPropagation();
    }

    /**
     * ミニマップ表示ボタンが切り替わった
     */
    btnToggleMapHandler = (e) => {
      const val = (<HTMLInputElement>e.currentTarget).checked;
      this.changeMinimapDisplay(val);
    }

    /**
     * マップ表示ボタンの状態でマップ表示を更新する
     */
    public updateMinimapDisplayByBtn() {
      const tar = document.getElementById('apprMinimap');
      if (!tar) return;
      const val = (<HTMLInputElement>tar).checked;
      this.changeMinimapDisplay(val);
    }

    /**
     * ミニマップの表示を切り替える
     */
    private changeMinimapDisplay=(val: boolean) => {
      if (val) document.getElementById('topview').style.display = 'block';
      else document.getElementById('topview').style.display = 'none';
    }
}
